export const CategoryMap = (() => {
  const catMap = new Map<string, number>();
  catMap.set('16', 1);
  catMap.set('32', 1);
  catMap.set('47', 1);
  catMap.set('51', 1);
  catMap.set('26', 1);
  catMap.set('42', 1);
  catMap.set('53', 1);

  // Swimming Category
  catMap.set('19', 271);

  // Crossfit Category
  catMap.set('34', 235);

  // Wellness Category
  catMap.set('22', 15);

  // Vibration Training Category
  catMap.set('40', 238);

  // Mixed Martial Arts Category
  catMap.set('35', 253);

  //  EMS Category
  catMap.set('41', 264);

  //  Yoga Category
  catMap.set('43', 6);

  //  Pilates Category
  catMap.set('44', 4);

  //  Qi Gong and Tai Chi Category
  catMap.set('49', 240);

  //  Personal Training Category
  catMap.set('50', 265);

  //  Dancing Category
  catMap.set('52', 7);

  return catMap;
})();
